<template>
  <ul>
    <profile-option
      v-for="option in profile.options"
      :profile="profile"
      :option="option"
      :key="option.id"
      :index="index"
      :selections="selections"
      @bus="bus"
    ></profile-option>
  </ul>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    selections: {
      type: Object
    }
  },
  components: {
    ProfileOption: defineAsyncComponent(() => 
      import('./CustomFacilityProfileOption.vue')
    )
  },
  methods: {
    bus(data) {
      this.$emit('bus', data)
    }
  }
}
</script>
